import { Template } from "../models/template";

export const SMS_TEMPLATES: Template[] = [

  new Template(
    -1,
    'Class Schedule Reminder',
    null, 
    'This is a friendly reminder that your <class> for <term> starts on <date> <time> at <campus>. Matrix Education 1300 008 008',
    ['allUsers'],
    1,
    'class-schedule-reminder'),

  new Template(
    -1,
    'Cancelled Class',
    null, 
    'Your <class> lesson has been postponed for today. A replacement lesson will be held in Week 10. Apologies and kindest regards, Matrix Education 1300 008 008',
    ['allUsers'],
    1,
    'cancelled-class'),

  new Template(
    -1,
    'Maths Homework Reminder',
    null, 
    'All Maths homework must be submitted by your child’s last lesson of the term. Any homework submitted after this will not be marked – Maths Team 1300 008 008',
    ['allUsers'],
    1,
    'maths-homework-reminder'),

  new Template(
    -1,
    'No Homework Submission',
    null, 
    '<student> has not submitted his/her <subject> homework. Please speak to <student> about completing his/her homework next week. Matrix 1300 008 008>',
    ['allUsers'],
    1,
    'no-homework-submission'),

  new Template(
    -1,
    'Replacement Class Schedule Reminder',
    null, 
    'Hi <name>, this is a reminder that you will be teaching <class> tomorrow <time> at <campus>. Matrix Education 1300 008 008',
    ['allUsers'],
    1,
    'replacement-class-schedule-reminder'),

  new Template(
    -1,
    'Teacher Class Schedule Reminder',
    null, 
    'Hi <name>, this is a reminder of your teaching schedule on <date>: <class> at <campus>. Matrix Education 1300 008 008',
    ['allUsers'],
    1,
    'teacher-class-schedule-reminder'),

  new Template(
    -1,
    'Week 10 Class Reminder',
    null, 
    'This is a friendly reminder that you have a Week 10 class for <class> tomorrow at <campus>. Matrix Education 1300 008 008',
    ['allUsers'],
    1,
    'week-10-class-reminder'),
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/sms-templates.ts